import App from "App";
import ErrorBoundary from "components/atoms/ErrorBoundary/ErrorBoundary";
import React, { Component } from 'react';

class OktaSecurityWrapper extends Component {
    render() {
        return <ErrorBoundary>
            <App />
        </ErrorBoundary>
    }
}

export default OktaSecurityWrapper